import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
    selector: 'app-shift-list',
    templateUrl: './../../../templates/forms/modals/list-request-list.copmonent.html',
})
export class ListRequestListComponent implements OnInit {


    @Input()
    modalShow: boolean = true;


    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "ListRequestListid"

    dataObj: any;
    listReqListList = [];
    searchFields: any[] = ['SHIFT_ID', 'IN_TIME', 'OUT_TIME', 'SHIFT_NO'];
    public searchString;
    constructor(
        public langService: LangService,
        public gridService: GridService,
        private dataLoadService: DataLoadService) {
        this.colObj = [
            { headerName: 'SHIFT_ID', field: 'SHIFT_ID', sortable: true, resizable: true, hide: false },
            { headerName: 'IN_TIME', field: 'IN_TIME', sortable: true, resizable: true, hide: false },
            { headerName: 'OUT_TIME', field: 'OUT_TIME', sortable: true, resizable: true, hide: false },
            { headerName: 'SHIFT_NO', field: 'SHIFT_NO', sortable: true, resizable: true, hide: false },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);

        this.dataLoadService.load('FG_HR_COMM_SHIFT', JSON.parse(JSON.stringify({ P_COMPANY_NO: null }))).subscribe(result => {
            this.listReqListList = result.body;
        })

    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}
